import { render, staticRenderFns } from "./static-field.vue?vue&type=template&id=0792a8da&scoped=true&"
import script from "./static-field.vue?vue&type=script&lang=js&"
export * from "./static-field.vue?vue&type=script&lang=js&"
import style0 from "./static-field.vue?vue&type=style&index=0&id=0792a8da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0792a8da",
  null
  
)

export default component.exports